import * as React from "react";
const SvgFiRrWaterLadder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-water-ladder_svg__a)">
      <path
        fill="#062147"
        d="M5 18a1 1 0 0 0 1-1v-3h12v3a1 1 0 1 0 2 0V5c0-1.654 1.346-3 3-3a1 1 0 1 0 0-2c-2.757 0-5 2.243-5 5v1H6V5c0-1.654 1.346-3 3-3a1 1 0 1 0 0-2C6.243 0 4 2.243 4 5v12a1 1 0 0 0 1 1M18 8v4H6V8zm5.668 14.978A3.99 3.99 0 0 1 21 24a4.37 4.37 0 0 1-3-1.226A4.37 4.37 0 0 1 15 24a4.37 4.37 0 0 1-3-1.226A4.37 4.37 0 0 1 9 24a4.37 4.37 0 0 1-3-1.226A4.37 4.37 0 0 1 3 24a3.99 3.99 0 0 1-2.668-1.022 1 1 0 1 1 1.336-1.488c.366.329.84.511 1.332.511.884 0 1.784-.58 2.053-1.322.094-.275.4-.677.923-.677s.881.416.97.677c.27.742 1.169 1.322 2.053 1.322s1.784-.58 2.053-1.322c.084-.246.397-.677.897-.677.531 0 .903.401.997.677.27.742 1.169 1.322 2.053 1.322s1.784-.58 2.053-1.322c.094-.275.414-.678.947-.678s.843.42.946.678c.292.733 1.169 1.322 2.053 1.322.492 0 .966-.182 1.332-.511a1 1 0 0 1 1.336 1.488z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-water-ladder_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWaterLadder;
